import { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import RequestEstimateForm from './RequestEstimateForm';

const EstimateModal = ({ isOpen, onClose, props }) => {
    const [submitted, setSubmitted] = useState(false);
    if (!isOpen) return null;
    return (
        <Modal
            show={isOpen}
            onHide={() => {
                setSubmitted(false);
                onClose();
            }} // Close modal onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            {...props}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="form-h1">
                    {submitted ? 'Thank You!' : 'Request an Estimate'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {submitted ? (
                    <div className="success-message">
                        <p>We’ve received your request and will get back to you as soon as possible.</p>
                    </div>
                ) : (
                    <Row>
                        <Col xs={12} lg={6}>
                            <p className="body-normal">Fill out the form, and we will do our best to get back to you within 24 hours.</p>
                            <h2 className="form-h2">What happens next?</h2>
                            <p className="body-normal">
                                We’ll reach out to arrange a visit. Every property is unique, so we’ll examine your windows
                                and discuss your film options with you. Then we’ll provide you with an estimate, and you can
                                schedule the work.
                            </p>
                            <span />
                            <p className="body-normal">Quick, easy, and hassle-free!</p>
                        </Col>
                        <Col xs={12} lg={6}>
                            <RequestEstimateForm onSuccess={() => setSubmitted(true)} />
                        </Col>
                    </Row>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default EstimateModal;